import './Animation.scss'

import React, { useEffect, useRef, useState } from 'react'

import type { AnimationType } from '../Asset'
import { Image } from '../Image/Image'

type AnimationProps = AnimationType & {
  resetOnPause?: boolean
  thumbnailUrl?: string
  thumbnailAlt?: string
}

export const Animation: React.FC<AnimationProps> = ({
  title,
  url,
  defaultTime = 0,
  loop,
  forcePause,
  className,
  resetOnPause,
  thumbnailUrl,
  thumbnailAlt,
}) => {
  const videoRef = useRef<HTMLVideoElement>(null)
  const [isVideoReady, setIsVideoReady] = useState(false)

  useEffect(() => {
    const updatePlayback = async () => {
      try {
        if (forcePause) {
          videoRef.current?.pause()
          if (resetOnPause) videoRef.current!.currentTime = defaultTime
        } else {
          if (resetOnPause) videoRef.current!.currentTime = defaultTime
          await videoRef.current?.play()
        }
      } catch (err) {
        console.warn('Video playback error:', err)
      }
    }
    const frame = requestAnimationFrame(updatePlayback)
    return () => cancelAnimationFrame(frame)
  }, [forcePause, resetOnPause, defaultTime])

  return (
    <>
      {!isVideoReady && thumbnailUrl && (
        <Image
          alt={thumbnailAlt}
          objectFit={'cover'}
          src={thumbnailUrl}
          style={{
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            objectPosition: 'center center',
          }}
        />
      )}

      <video
        autoPlay={true}
        className={className || 'coral-animation'}
        loop={loop}
        muted={true}
        onCanPlay={() => setIsVideoReady(true)}
        playsInline={true}
        ref={videoRef}
        src={url}
        style={{
          visibility: isVideoReady ? 'visible' : 'hidden',
        }}
        title={title}
      />
    </>
  )
}
